/* eslint-disable: no-useless-escape */
import { store } from '@/store';

export const pick = (obj: any, keys: string[]) => {
  return keys.reduce((acc, key) => ({
    ...acc,
    [key]: obj[key],
  }), {});
};

// https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
export const isEmailValid = (email: string | any) => {
  if (typeof email !== 'string') return false;
  // eslint-disable-next-line no-useless-escape
  const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailReg.test(email);
};

export const isPhoneValid = (phone: string) => { // TODO
  return phone.length > 7 && !isNaN(+phone);
};

// TODO: [Sportybet]
// export const fixPhone = (phone = '') => {
//   const country = (store.state as any)['user'].country;
//   if (
//     phone &&
//     country === 'ke' &&
//     phone && !/^0/.test(phone)
//   ) {
//     const temp = `0${phone}`;
//     return temp.length > 18 ? temp.slice(0, 18) : temp;
//   } else if (phone && country === 'zm') {
//     if (!/^0/.test(phone) && phone.length === 9) {
//       return `0${phone}`;
//     }
//   }
//   return phone;
// };

export const isPswdValid = (pswd: string) => {
  return !!pswd.length;
};

export const formatMoney = (num: number | string) => {
  if (typeof num === 'string') {
    num = +num;
  }
  return (num / 10000).toFixed(2);
};

export const stringLengthWithoutSpace = (str: string) => {
  return str.trim().replace(/ /g, '').length;
};

export const combinedDescription = (description: string, issueMsg = '') => {
  return issueMsg ? `My Issue: ${issueMsg} + My description: ${description}` : description;
};

export const previewHelper = (htmlBodyString: string) => {
  const div = document.createElement('div');
  div.innerHTML = htmlBodyString;
  const text = div.textContent || div.innerText || '';
  return {
    html: htmlBodyString,
    isPreview: text.length > 75,
    text,
  };
};

export function round (num: number, decimals: number) {
  return Number(Math.round(Number(`${num}e${decimals}`)) + `e-${decimals}`);
}

export function waitFor (milliSeconds: number) {
  return new Promise(resolve => setTimeout(resolve, milliSeconds));
}
